import app from '../../firebase';

import {
    getFirestore,
    doc,
    getDoc,
    deleteDoc,
    updateDoc,
    getDocs,
    collection,
    query,
    where,
} from 'firebase/firestore';

import {
    getStorage,
    ref,
    deleteObject,
} from "firebase/storage";

import { useState, useEffect, }     from 'react';
import { useNavigate, useParams }   from 'react-router-dom';


export default function Seller() {
    const { productId } = useParams();
    const userId = localStorage.getItem('userId');

    const [profile, setProfile] = useState();
    const [seller, setSeller] = useState();
    const [product, setProduct] = useState();
    const [gallery, setGallery] = useState([]);

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const getProduct = () => {
        getDoc(doc(getFirestore(app), `products/${productId}`))
            .then(result => setProduct([result.id, result.data()]));
    }

    const getProfile = () => {
        if (!localStorage.getItem('userId')) return;
        getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => setProfile([result.id, result.data()]))
    }

    const getSeller = () => {
        getDoc(doc(getFirestore(app), `products/${productId}`))
        .then(result => {
            getDoc(doc(getFirestore(app), `users/${result.data().seller}`))
                .then(result => setSeller([result.id, result.data()]))
        })
    }

    const getGallery = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'gallery'), where('product_id', '==', productId)))
            .then(results => results.forEach(i => x.push([i.id, i.data()])));
        setGallery(x);
    }

    const deleteProduct = async () => {

        await getDocs(query(collection(getFirestore(app), 'gallery'), where('product_id', '==', productId)))
            .then(async results => {
                await results.forEach(i => {
                    deleteDoc(doc(getFirestore(app), 'gallery', i.id));
                    deleteObject(ref(getStorage(app), `gallery/${i.id}`));
                })
            });

        // delete from product folder in storage
        await deleteObject(ref(getStorage(app), `products/${productId}`));

        // delete product from firestore
        await deleteDoc(doc(getFirestore(app), 'products', productId));

        window.location.replace('/profile');
    }

    useEffect(() => {
        getProduct();
        getGallery();
        getProfile();
        getSeller();
    });

    return(
        <>
            <div className="container-fluid bg-light p-4">
                <div className="row g-5">
                    
                    <div className="col-lg-6">
                        <div className="h-100 rounded-3 text-center">

                            <img
                                src={product && product[1].image_url}
                                className="d-block mx-auto img-fluid shadow mb-2 w-75"
                                style={{ borderRadius: 20 }}
                                alt={product && product[1].name}
                            />
                            
                            {
                                gallery.map(i => (
                                    <img
                                        src={i[1].image_url}
                                        className="img-fluid shadow m-1"
                                        style={{ borderRadius: 20, width: 128, height: 140 }}
                                        alt=""
                                    />
                                    ))
                            }
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="p-4">

                            {/* product name */}
                            <input
                                type="text"
                                className="d-block fw-bold fs-4 w-100 mb-2"
                                defaultValue={ product && product[1].name }
                                style={{ backgroundColor: 'inherit', border: 'none' }}
                                onChange={data => {
                                    updateDoc(doc(getFirestore(app), 'products', product[0]), { name: data.target.value, name_keywords: data.target.value.toLowerCase().split(' ')});
                                }}
                            />
                            
                            
                            {/* price */}
                            <input
                                type="number"
                                className="d-block text-success fs-5 w-50 mb-2"
                                defaultValue={ product && product[1].price }
                                style={{ backgroundColor: 'inherit', border: 'none' }}
                                onChange={data => updateDoc(doc(getFirestore(app), 'products', product[0]), { price: parseFloat(data.target.value) })}
                            />
                            
                            <span className="bg-success text-light rounded-3 fw-bold px-2 py-1">{product && product[1].category}</span>

                            <hr />

                            {/* Product Description */}
                            <textarea
                                rows="10"
                                className="d-block w-100 mb-4"
                                defaultValue={ product && product[1].description }
                                style={{ backgroundColor: 'inherit', border: 'none', resize: 'none' }}
                                onChange={data => { updateDoc(doc(getFirestore(app), 'products', product[0]), { description: data.target.value, description_keywords: data.target.value.toLowerCase().split(' ')}); }}
                            ></textarea>

                            {/* delete product */}
                            <button
                                className="btn btn-lg btn-danger"
                                onClick={deleteProduct}
                            >Delete Product</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}